import React, { useState } from 'react';
import { X } from 'lucide-react';
import './UserConfigModal.scss';

const UserConfigModal = ({ 
  isOpen, 
  onClose, 
  visibleColumns, 
  setVisibleColumns,
  tableSettings,
  setTableSettings
}) => {
  const [localVisibleColumns, setLocalVisibleColumns] = useState(visibleColumns);
  const [localTableSettings, setLocalTableSettings] = useState(tableSettings);

  if (!isOpen) return null;

  const handleColumnVisibilityChange = (columnKey) => {
    setLocalVisibleColumns(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }));
  };

  const handleTableSettingChange = (key, value) => {
    setLocalTableSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const setMinimalView = () => {
    setLocalVisibleColumns({
      id: true,
      email: true,
      name: true,
      phone: false,
      doterraId: false,
      mentor: false,
      status: true,
      createdAt: false,
      role: false,
      actions: true
    });
  };

  const setBasicView = () => {
    setLocalVisibleColumns({
      id: true,
      email: true,
      name: true,
      phone: true,
      doterraId: true,
      mentor: false,
      status: true,
      createdAt: true,
      role: false,
      actions: true
    });
  };

  const setDetailedView = () => {
    setLocalVisibleColumns({
      id: true,
      email: true,
      name: true,
      phone: true,
      doterraId: true,
      mentor: true,
      status: true,
      createdAt: true,
      role: true,
      actions: true
    });
  };

  const resetToDefault = () => {
    setLocalVisibleColumns({
      id: true,
      email: true,
      name: true,
      phone: true,
      doterraId: true,
      mentor: true,
      status: true,
      createdAt: true,
      role: false,
      actions: true
    });
    setLocalTableSettings({
      rowsPerPage: 10,
      compactView: false,
      showAdvancedInfo: true
    });
  };

  const saveConfiguration = () => {
    setVisibleColumns(localVisibleColumns);
    setTableSettings(localTableSettings);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="config-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Configurări Tabel</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-content">
          {/* Column Visibility Section */}
          <div className="config-section full-width">
            <h4>Coloane Vizibile</h4>
            
            {/* Quick Presets */}
            <div className="preset-buttons">
              <button className="preset-btn" onClick={setMinimalView}>
                Minimal
              </button>
              <button className="preset-btn" onClick={setBasicView}>
                De bază
              </button>
              <button className="preset-btn" onClick={setDetailedView}>
                Detaliat
              </button>
            </div>

            <div className="config-grid">
              {Object.entries({
                id: 'ID',
                email: 'Email',
                name: 'Nume',
                phone: 'Telefon',
                doterraId: 'doTERRA ID',
                mentor: 'Mentor doTERRA ID',
                status: 'Status',
                createdAt: 'Data creării',
                role: 'Rol',
                actions: 'Acțiuni'
              }).map(([key, label]) => (
                <label key={key} className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={localVisibleColumns[key]}
                    onChange={() => handleColumnVisibilityChange(key)}
                  />
                  <span className="checkmark"></span>
                  {label}
                </label>
              ))}
            </div>
          </div>

          {/* Table Settings Section */}
          <div className="config-section">
            <h4>Setări Tabel</h4>
            <div className="config-row">
              <label>Rânduri per pagină:</label>
              <select
                value={localTableSettings.rowsPerPage}
                onChange={(e) => handleTableSettingChange('rowsPerPage', parseInt(e.target.value))}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            
            <div className="config-row">
              <label className="config-checkbox">
                <input
                  type="checkbox"
                  checked={localTableSettings.compactView}
                  onChange={(e) => handleTableSettingChange('compactView', e.target.checked)}
                />
                <span className="checkmark"></span>
                Vizualizare compactă
              </label>
            </div>
            
            <div className="config-row">
              <label className="config-checkbox">
                <input
                  type="checkbox"
                  checked={localTableSettings.showAdvancedInfo}
                  onChange={(e) => handleTableSettingChange('showAdvancedInfo', e.target.checked)}
                />
                <span className="checkmark"></span>
                Afișează informații avansate
              </label>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={resetToDefault}>
            Resetează la Implicit
          </button>
          <button className="btn btn-primary" onClick={saveConfiguration}>
            Salvează Configurația
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserConfigModal;
